module.exports = __webpack_public_path__ + "static/media/helena-lose.5c69f747.png";